import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { SearchIcon } from 'foundations-assets';
import I18n from 'I18n';
import { useIsFallbackModeEnabled } from 'find-and-filter-data/views-data/public';
import { jsx as _jsx } from "react/jsx-runtime";
const SearchAndFilterModeIcon = ({
  clickHandler = () => {}
}) => {
  const customViewsFallbackModeEnabled = useIsFallbackModeEnabled();
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: !customViewsFallbackModeEnabled,
    headingText: I18n.text('conversations-inbox-ui.custom-views.fallbackMode.searchAndFilterButtonHeader'),
    placement: "right",
    title: I18n.text('conversations-inbox-ui.custom-views.fallbackMode.navLinkText'),
    children: /*#__PURE__*/_jsx(IconButton, {
      disabled: customViewsFallbackModeEnabled,
      use: "transparent",
      onClick: clickHandler,
      placement: "right",
      "data-test-id": "enter-search-and-filtering-mode-button",
      children: /*#__PURE__*/_jsx(SearchIcon, {
        size: "500"
      })
    })
  });
};
SearchAndFilterModeIcon.displayName = 'SearchAndFilterModeIcon';
export default SearchAndFilterModeIcon;